import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Calendar, Heart, User, LogOut, Wallet, Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import logo from "@/assets/logo.png";

const NAV = [
  { to: "/dashboard", label: "Overview", icon: Home, end: true },
  { to: "/dashboard/appointments", label: "Appointments", icon: Calendar },
  { to: "/dashboard/wallet", label: "My Wallet", icon: Wallet },
  { to: "/dashboard/favourites", label: "Favourites", icon: Heart },
  { to: "/dashboard/profile", label: "Profile", icon: User },
];

export default function CustomerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logout();
    navigate("/");
  };
  return (
    <div className="min-h-screen flex bg-hblack text-white">
      <aside className="w-64 shrink-0 border-r border-white/10 bg-gradient-to-b from-[#0a0a0a] via-black to-[#0a0a0a] fixed top-0 bottom-0 left-0 flex flex-col justify-between shadow-2xl z-30" data-testid="customer-sidebar">
        <div>
          <div className="p-6 border-b border-white/10 bg-black/60">
            <div className="flex items-center gap-3 mb-2">
              <img src={logo} alt="Hammam Logo" className="h-10 w-auto object-contain" />
              <span className="font-heading text-sm text-white font-bold tracking-wider">Hammam Men Spa</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-emerald-400 font-extrabold mt-1 flex items-center gap-1.5">
              <Sparkles size={12} className="text-amber-400" /> Guest VIP Console
            </div>
          </div>

          <nav className="py-4 px-2 space-y-1 overflow-y-auto max-h-[calc(100vh-180px)] scrollbar-none">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`customer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all border-l-4 ${
                    isActive
                      ? "text-amber-300 border-amber-400 bg-gradient-to-r from-amber-500/20 to-amber-500/5 shadow-md shadow-yellow-950/20 font-bold"
                      : "text-white/70 border-transparent hover:text-amber-300 hover:bg-white/5"
                  }`
                }
              >
                <n.icon size={18} strokeWidth={1.8} />
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="border-t border-white/10 p-5 bg-black/80">
          <div className="text-xs font-bold text-white mb-0.5 truncate">{user?.name}</div>
          <div className="text-[11px] text-white/50 mb-3 truncate">{user?.email}</div>
          <button
            data-testid="customer-logout"
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 border border-red-500/40 bg-red-950/20 hover:bg-red-900/40 hover:border-red-400 text-red-300 py-2.5 rounded-xl text-xs uppercase tracking-widest font-extrabold transition-all shadow-md shadow-red-950/30"
          >
            <LogOut size={14} /> Sign Out
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen bg-hblack">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="p-8 lg:p-10"
        >
          <Outlet />
        </motion.div>
      </main>
    </div>
  );
}
